// olap-client/src/components/MobNavBar.js
import React, { useContext } from "react";
import { Context } from "../index";
import { NavLink } from "react-router-dom";
import { ADMIN_ROUTE, INDEX_ROUTE, LOGIN_ROUTE } from "../utils/consts";
import { observer } from 'mobx-react-lite';
import { useNavigate } from "react-router-dom";
import { unsubscribeFromPush } from '../utils/pushNotifications';

const MobNavBar = observer(() => {
    const { user } = useContext(Context);
    const navigate = useNavigate();

    const logOut = async () => {
        console.log('🚪 [Logout] Starting logout process...');
        
        // 1. Отписываемся от push ПЕРЕД очисткой токена
        try {
            await unsubscribeFromPush();
            console.log('✅ [Logout] Push unsubscribed');
        } catch (e) {
            console.error('❌ [Logout] Push unsubscribe error:', e);
        }
        
        // 2. Очищаем состояние
        user.setUser({});
        user.setIsAuth(false);
        
        // 3. Очищаем localStorage
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        
        // 4. Переходим на главную
        navigate(INDEX_ROUTE);
    };

    return (
        <nav className="mobile-nav" style={{"zIndex":1}}>
            {
            (user.isAuth && user.user.role === 'ADMIN') ?
                <>
                    <NavLink role="button" className="bloc-icon" to={INDEX_ROUTE}>
                        <i className="bi bi-house-fill"></i>
                    </NavLink>
                    <NavLink role="button" className="bloc-icon" to={ADMIN_ROUTE}>
                        <i className="bi bi-gear"></i>
                    </NavLink>
                    <NavLink onClick={() => logOut()} className="bloc-icon" to="">
                        <i className="bi bi-door-open"></i>
                    </NavLink>
                </>
                : (user.isAuth && user.user.role === 'RUK+') ?
                <>
                    <NavLink role="button" className="bloc-icon" to={INDEX_ROUTE}>
                        <i className="bi bi-house-fill"></i>
                    </NavLink>
                    <NavLink role="button" className="bloc-icon" to={ADMIN_ROUTE}>
                        <i className="bi bi-gear"></i>
                    </NavLink>
                    <NavLink onClick={() => logOut()} className="bloc-icon" to="">
                        <i className="bi bi-door-open"></i>
                    </NavLink>
                </>
                : (user.isAuth && user.user.role === 'RUK') ?
                <>
                    <NavLink role="button" className="bloc-icon" to={INDEX_ROUTE}>
                        <i className="bi bi-house-fill"></i>
                    </NavLink>
                    <NavLink onClick={() => logOut()} className="bloc-icon" to="">
                        <i className="bi bi-door-open"></i>
                    </NavLink>
                </>
                : (user.isAuth && user.user.role === 'MAN') ?
                <>
                    <NavLink role="button" className="bloc-icon" to={INDEX_ROUTE}>
                        <i className="bi bi-house-fill"></i>
                    </NavLink>
                    <NavLink onClick={() => logOut()} className="bloc-icon" to="">
                        <i className="bi bi-door-open"></i>
                    </NavLink>
                </>
                :
                <>
                    <NavLink role="button" className="bloc-icon" to={LOGIN_ROUTE}>
                        <i className="bi bi-door-closed"></i>
                    </NavLink>
                </>
            }     
        </nav>
    );
});

export default MobNavBar;